import { RouteConfig } from 'vue-router/types/router';
import MswCatalogLoginOptions from './msw-catalog-login-option.vue';

export const guestOrMswLogin: RouteConfig = {
  path: 'guestormswlogin',
  component: MswCatalogLoginOptions,
};
